module.exports = __webpack_public_path__ + "img/pro_s2_icon2.a2250ee8.png";